import React from 'react';
import { HelpCircle } from 'lucide-react';

/** Inline page-guide icon (same symbol everywhere; size varies by screen). */
export const TourHelpIcon: React.FC = () => (
  <span
    className="product-tour-help-icon mx-0.5 inline-flex h-4 w-4 shrink-0 items-center justify-center align-middle text-teal-700 dark:text-teal-300"
    aria-hidden
  >
    <HelpCircle className="h-3.5 w-3.5" strokeWidth={2} />
  </span>
);

/** @deprecated Use TourHelpIcon */
export const TourBannerHelpIcon = TourHelpIcon;

/** @deprecated Use TourHelpIcon */
export const TourModalHelpIcon = TourHelpIcon;